module.exports = __webpack_public_path__ + "img/1.3ec304c9.jpg";